<!--Inspired by Angular material datepicker components-->
<!--Refer to: https://github.com/angular/components/blob/master/src/material/datepicker/calendar-body.html-->

@for (row of rows; track $index; let rowIndex = $index) {
  <tr role="row">
    @for (item of row; track item.id; let colIndex = $index) {
      <td
        role="gridcell"
        class="mat-calendar-body-cell"
        [ngClass]="item.cssClasses"
        [tabindex]="_isActiveCell(rowIndex, colIndex) ? 0 : -1"
        [class.mat-calendar-body-disabled]="!item.enabled"
        [class.mat-calendar-body-active]="_isActiveCell(rowIndex, colIndex)"
        [attr.aria-label]="item.ariaLabel"
        [attr.aria-disabled]="!item.enabled || null"
        [attr.aria-selected]="isSelected(item.value)"
        (click)="_cellClicked(item, $event)"
        [style.width]="_cellWidth"
        [style.paddingTop]="_cellPadding"
        [style.paddingBottom]="_cellPadding"
      >
        <div
          class="mat-calendar-body-cell-content"
          [class.mat-calendar-body-selected]="isSelected(item.value)"
          [class.mat-calendar-body-today]="todayValue === item.value"
        >
          {{ item.displayValue }}
        </div>
      </td>
    }
  </tr>
}
